import React, { useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { useTheme } from '@mui/material/styles';
import { Height } from '../util/ScreenHeight'
// import ErrorM from '../util/ErrorM'
// import AskDialog from '../util/AskDialog';
// import Photo from '@mui/icons-material/Photo'
// import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { makeStyles } from '@mui/styles';
import MoreVert from '@mui/icons-material/MoreVert';
import Button from '@mui/material/Button';
import RecSetting from './RecSetting';

import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import AlertD from '../util/AlertD';
import { Stack } from '@mui/material';
import { red } from '@mui/material/colors';
import MoneySetting from './MoneySetting';
import { Typography } from '@mui/material';

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -10,
        top: 5,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
            // width: 250,
        },
    },
};


const useStyles = makeStyles(theme => ({
    root: {
        '& .MuiOutlinedInput-root': {
            borderRadius: 0
        },
    }

    //  '& .MuiDataGrid-colCell, .MuiDataGrid-cell': {
    //     borderRight: `1px solid ${theme.palette.type === 'light' ? '#f0f0f0' : '#303030'
    //         }`,
    // },
}));


export default function RecSelector(props) {
    const [showAlert, setShowAlert] = React.useState(false);
    const [alertMsg, setAlertMsg] = React.useState(null);

    const [openSetting, setOpenSetting] = React.useState(false);
    const [openSetting1, setOpenSetting1] = React.useState(false);

    const theme = useTheme();
    const classes = useStyles();

    const [regTp, setRegTp] = React.useState("0");
    const [runYear, setRunYear] = React.useState(1);

    const handleChange = (event) => {
        if (hasLic())
            setRegTp(event.target.value);
        else setRegTp("0");
    };

    const handleYearChange = (event) => {
        setRunYear(event.target.value);
    };

    useEffect(() => {
        if (props.refresh != null) props.refresh(regTp, runYear)
    }, [regTp, runYear]);

    const hasLic = () => {
        return localStorage.getItem('noad') != null && localStorage.getItem('noad') === "1"
    }

    return (
        <Box sx={{ width: '100%', textAlign: 'left', display: 'inline-flex', p: 0, bgcolor: theme.palette.mode === "light" ? "secondary.light" : null }} >
            {openSetting ? <RecSetting tid={regTp} refresh={props.fetchData} open={openSetting} close={setOpenSetting}></RecSetting> : null}
            {openSetting1 ? <MoneySetting money={props.money} tid={regTp} refresh={props.fetchData} open={openSetting1} close={setOpenSetting1}></MoneySetting> : null}
            {showAlert ? <AlertD desc={alertMsg} open={showAlert} close={setShowAlert}></AlertD> : null}

            <Stack direction={"row"} spacing={0.2} sx={{ width: "100%", height: Height.subheader - 3, maxHeight: Height.subheader }}>
                <FormControl variant="filled" fullWidth hiddenLabel >
                    <Select
                        labelId="tpLabel"
                        id="tp"
                        value={regTp}
                        label="tpLabel"
                        onChange={handleChange}
                    >
                        <MenuItem value={"0"}>定期投資計畫1</MenuItem>
                        {hasLic() ? <MenuItem value={"1"}>定期投資計畫2</MenuItem> : <MenuItem value={"1"}>定期投資計畫2 <Typography variant="caption">(VIP專屬)</Typography></MenuItem>}
                        {hasLic() ? <MenuItem value={"2"}>定期投資計畫3</MenuItem> : <MenuItem value={"2"}>定期投資計畫3 <Typography variant="caption">(VIP專屬)</Typography></MenuItem>}
                        {hasLic() ? <MenuItem value={"3"}>定期投資計畫4</MenuItem> : <MenuItem value={"3"}>定期投資計畫4 <Typography variant="caption">(VIP專屬)</Typography></MenuItem>}
                        {hasLic() ? <MenuItem value={"4"}>定期投資計畫5</MenuItem> : <MenuItem value={"4"}>定期投資計畫5 <Typography variant="caption">(VIP專屬)</Typography></MenuItem>}
                    </Select>
                </FormControl>
                {/* <FormControl variant="filled" fullWidth hiddenLabel >
                    <Select
                        labelId="yearLabel"
                        id="year"
                        value={runYear}
                        label="yearLabel"
                        onChange={handleYearChange}
                    >
                        <MenuItem value={1}>1年</MenuItem>
                        <MenuItem value={2}>2年</MenuItem>
                        <MenuItem value={3}>3年</MenuItem>
                        <MenuItem value={4}>4年</MenuItem>
                        <MenuItem value={5}>5年</MenuItem>
                        <MenuItem value={6}>6年</MenuItem>
                        <MenuItem value={7}>7年</MenuItem>
                        <MenuItem value={8}>8年</MenuItem>
                        <MenuItem value={9}>9年</MenuItem>
                        <MenuItem value={10}>10年</MenuItem>
                    </Select>
                </FormControl> */}
            </Stack>
            {/* {props.enableSetting && <Button variant='contained' sx={{ height: Height.subheader - 3, maxHeight: Height.subheader, whiteSpace: 'nowrap', borderRadius: '0px', mr: 0.2}} size="small" color="secondary" disableElevation onClick={e => clear()}>清除</Button>} */}
            <Stack spacing={0.1} direction={"row"}>
                {props.enableSetting && <Button variant='contained' sx={{ height: Height.subheader - 3, maxHeight: Height.subheader, whiteSpace: 'nowrap', borderRadius: '0px' }} color="neutral" size="small" disableElevation onClick={e => setOpenSetting(true)}>新增</Button>}
                {/* {props.enableSetting && <Button variant='contained' sx={{ height: Height.subheader - 3, maxHeight: Height.subheader, whiteSpace: 'nowrap', borderRadius: '0px' }} color="neutral" size="small" disableElevation onClick={e => setOpenSetting1(true)}>目標</Button>} */}
            </Stack>
        </Box>
    );
}
